export const PREVIOUS_ACTION = 'PREV';

export const NEXT_ACTION = 'NEXT';

export const DELAY_SHOW_DURATION = 300;

export const DELAY_HIDE_DURATION = 500;
